'use client'

import { useEffect, useState } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'

export const useIsRouterLoading = () => {
	const pathname = usePathname()
	const searchParams = useSearchParams()
	const [isLoading, setIsLoading] = useState(false)

	useEffect(() => {
		setIsLoading(false)
	}, [pathname, searchParams])

	useEffect(() => {
		const handleStart = () => setIsLoading(true)

		const handleClick = (event: MouseEvent) => {
			const target = event.target
			if (!(target instanceof Element)) return

			const anchor = target.closest('a[href]')
			if (!anchor || anchor.getAttribute('target') === '_blank') return

			const href = anchor.getAttribute('href')
			if (!href || href.startsWith('#') || href.startsWith('mailto:')) return

			try {
				const url = new URL(href, window.location.origin)
				if (url.origin !== window.location.origin) return

				const currentPath = `${pathname}${searchParams.size ? `?${searchParams}` : ''}`
				const nextPath = `${url.pathname}${url.search}`

				if (nextPath !== currentPath) {
					handleStart()
				}
			} catch {
				// ignore invalid URLs
			}
		}

		window.addEventListener('popstate', handleStart)
		document.addEventListener('click', handleClick, true)

		return () => {
			window.removeEventListener('popstate', handleStart)
			document.removeEventListener('click', handleClick, true)
		}
	}, [pathname, searchParams])

	return isLoading
}
